import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './carousel.css';

function Carousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [items, setItems] = useState([
    { image: require('../assets/images/testimonial-img.png'), author: '— Michael Anderson, VP of Operations, CarePath Health Plan', text: '"Elevate has completely transformed the way we approach risk adjustment. Their streamlined solutions have significantly improved our accuracy and compliance, saving our team countless hours. We’ve seen a measurable impact on both efficiency and patient care. Elevate is a true partner in helping us achieve our goals!"'},
    { image: require('../assets/images/testimonial-img-2.png'), author: '— Williams L, Senior Data Analyst, VitalEdge Healthcare', text: 'Elevate’s platform is intuitive, reliable, and packed with features that make my job easier. The ability to integrate data seamlessly and access actionable insights has been invaluable for our analytics team. Elevate’s solutions have elevated our approach to risk adjustment!' },
    { image: require('../assets/images/testimonial-img-3.png'), author: 'Sarah M., Healthcare Operations Manager', text: 'Elevate’s solutions have completely transformed the way we manage risk adjustment. Their expertise and advanced analytics helped us improve coding accuracy and streamline our processes, saving us time and resources. We couldn’t be happier with the results!' },
  ]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveIndex((activeIndex + 1) % items.length);
    }, 3000);
    return () => clearInterval(intervalId);
  }, [activeIndex, items.length]);

  const handleNext = () => {
    setActiveIndex((activeIndex + 1) % items.length);
  };

  const handlePrev = () => {
    setActiveIndex((activeIndex - 1 + items.length) % items.length);
  };

  return (
    <div id="carousel" className="carousel slide" data-ride="carousel">
      <div className="carousel-inner">
        {items.map((item, index) => (
          <div
            key={index}
            className={`carousel-item ${index === activeIndex ? 'active' : ''}`}
            style={{
              transition: 'transform 0.5s ease-in-out',
              transform: `translateX(${index === activeIndex ? 0 : '100%'})`,
            }}
          >
            <div className="row">
              <div className="col-md-6">
                <img src={item.image} alt="Carousel Image" className="img-fluid" />
              </div>
              <div className="col-md-6">
                <p className="carousel-text ms-3">{item.text}</p>
                <p className="carousel-author ms-3">{item.author}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <a
        className="carousel-control-prev"
        href="#carousel"
        role="button"
        data-slide="prev"
        onClick={handlePrev}
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
      </a>
      <a
        className="carousel-control-next"
        href="#carousel"
        role="button"
        data-slide="next"
        onClick={handleNext}
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
      </a>
      <style>
        {`
          .carousel-indicators li {
            background-color: green;
          }
          .carousel-indicators li.active {
            background-color: blue;
          }
        `}
      </style>
    </div>
  );
}

export default Carousel;